import { CategoryId } from '@business/entities/category';
import { Endpoint } from '../endpoint';
import { ProjectServiceResponse, ProjectServiceType } from '@business/entities/project';

export function fetchServices(isPublic?: boolean, isActive = false) {
  const status = isActive ? 'active' : '';
  if (isPublic) return Endpoint.get<ProjectServiceResponse[]>(`@gc/public/project/services`, { params: { status } });
  else return Endpoint.get<ProjectServiceResponse[]>(`@gc/project/services`, { params: { status } });
}

export function fetchService(id: string) {
  return Endpoint.get<ProjectServiceResponse>(`@gc/project/services/service/${id}`);
}

export function createService(data: Partial<ProjectServiceResponse>) {
  return Endpoint.post<ProjectServiceResponse>(`@gc/project/services`, { data });
}

export function updateService(id: string, data: Partial<ProjectServiceResponse>) {
  return Endpoint.patch<ProjectServiceResponse>(`@gc/project/services/${id}`, { data });
}

export function deleteService(serviceId: string) {
  return Endpoint.delete<ProjectServiceResponse>(`@gc/project/services/${serviceId}`);
}

export function setMarketingServices(ids: string[]) {
  return Endpoint.post<ProjectServiceResponse[]>(`@gc/project/services/marketing-service`, { data: { ids } });
}

export function changeType(id: string, type: ProjectServiceType) {
  return Endpoint.patch<ProjectServiceResponse>(`@gc/project/services/change-type/${id}`, { data: { type } });
}

export function updateCategories(id: string, ids: CategoryId[]) {
  return Endpoint.patch<ProjectServiceResponse>(`@gc/project/services/update-categories/${id}`, { data: { ids } });
}
